import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { useUIStore } from '../../store/uiStore';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function DashboardLayout(): React.ReactElement {
  const { user } = useAuthStore();
  const { setMobileSidebarOpen } = useUIStore();

  // Close mobile sidebar on resize to desktop
  useEffect(() => {
    const handleResize = (): void => {
      if (window.innerWidth >= 768) {
        setMobileSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setMobileSidebarOpen]);

  return (
    <div className="h-screen overflow-hidden flex">
      {/* Sidebar */}
      <Sidebar user={user} />

      {/* Main content area */}
      <div className="flex flex-col flex-1 min-w-0 transition-all duration-300">
        <TopBar user={user} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
